<template>
  <table
    v-if="selectedCategory === 'customer-experience' && isV2"
    :class="[$style.table]"
  >
    <tbody>
      <tr>
        <th>
          {{
            localizedStrings['current-quarter-review-count'] ||
            'Current Quarter Review Count'
          }}
        </th>
      </tr>
      <tr>
        <td :class="$style.reviewsCount">
          <span>{{ computedQuarterReviewCountCopy }}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <table
    v-if="selectedCategory === 'customer-experience' && reviews.length > 0"
    :class="[$style.reviewsTable, isV2 && $style.isV2]"
  >
    <tbody>
      <tr>
        <th>
          {{
            localizedStrings['customer-review-reason-selected'] ||
            'Customer Review - Reason Selected'
          }}
        </th>
        <th v-if="!isV2">{{ localizedStrings['count'] || 'Count' }}</th>
        <th v-if="isV2">{{ localizedStrings['positive'] || 'Positive' }}</th>
        <th v-if="isV2">{{ localizedStrings['negative'] || 'Negative' }}</th>
      </tr>
      <tr v-for="review in reviews" :key="review.key">
        <td>{{ review.reason }}</td>
        <td v-if="!isV2">{{ review.count || 0 }}</td>
        <td v-if="isV2">{{ review.positive || 0 }}</td>
        <td v-if="isV2">{{ review.negative || 0 }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
const props = defineProps<{
  selectedCategory: string
  reviews: {
    key: string
    count: number | undefined | null
    positive: number | undefined | null
    negative: number | undefined | null
    reason: string
  }[]
  isV2: boolean
  quarterReviewCount: number
  quarterReviewCountCopy: string
}>()

const { localizedStrings } = useLocalizedStrings()

const computedQuarterReviewCountCopy = computed(() => {
  const copy =
    props.quarterReviewCountCopy || '{{ quarterReviewCount }}/10 reviews'

  if (copy?.includes(`{{ quarterReviewCount }}`)) {
    return copy.replace(
      `{{ quarterReviewCount }}`,
      String(props.quarterReviewCount),
    )
  }

  return copy
})
</script>

<style lang="scss" module>
.table,
.reviewsTable {
  tr {
    display: grid;

    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;

    &:first-child {
      background: #eeeeee;
      border: 1px solid #d1d1d1;
    }

    th,
    td {
      padding: 16px;
    }

    th {
      font-weight: 600;

      &:first-child {
        text-align: left;
      }
    }

    @include media('md') {
      column-gap: 24px;
    }
  }
}

.reviewsTable {
  tr {
    grid-template-columns: auto 100px;

    td {
      &:not(:first-child) {
        text-align: center;
      }
    }
  }

  &.isV2 {
    tr {
      grid-template-columns: auto 100px 100px;
    }
  }
}

.reviewsCount {
  span {
    display: block;

    &:first-child {
      font-weight: 600;
    }

    &:nth-child(2) {
      font-size: 14px;
    }
  }
}
</style>
